import { GetPropertyInsurancePropType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPropertyInsurance/getPropertyInsurance.type';
import { getPropertyInsuranceFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPropertyInsurance/getPropertyInsuranceFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPropertyInsuranceOptions = (
  {id,damaged_id}: GetPropertyInsurancePropType,
) => {
  return queryOptions({
    queryKey: ['damaged-property-insurance-get', id,damaged_id],
    queryFn: () => getPropertyInsuranceFunction({damaged_id,id}),
  });
};
